// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import CascaderSearch from './components/CascaderSearch.vue';
import eventBus from "../../../../../../util/eventBus";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            new Vue({
                el: model.dom,
                template: '<CascaderSearch :invoke="invoke" :taskListSource="taskListSource" :multiple="multiple" :levelNum="levelNum" :isCanSearch="isCanSearch" :getSelected="getSelected" :initSelected="initSelected" :themeNum="themeNum" />',
                components: {
                    CascaderSearch
                },
                data: {
                    multiple: 'true',//是否多选
                    levelNum: '1',//定义级联层数
                    isCanSearch: 'false',//是否可搜索（只支持搜索最后一级）
                    taskListSource: [],//源数据 格式：[{"first_class":"教育/培训/科研","second_class":"中小学课程辅导","third_class":"兼职教师"},{},{}]
                    getSelected: '',//后台去获取已选值
                    updateTaskList: [],//后台去更新数据源
                    initSelected: [],  //后台去初始化默认值
                    themeNum:"#5582F3"
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    //初始化控件配置信息
                    if (props.configItems) {
                        for (let x in props.configItems) {
                            this[props.configItems[x].key] = props.configItems[x].value;
                        }
                    }
                    //初始化主题色
                    if(props.themeNum){
                        this.themeNum = props.themeNum;
                    }
                    //接受控件数据，选项列表和默认值
                    if (props.data && props.data.hasOwnProperty('setTaskList') && props.data.setTaskList) {
                        this.taskListSource = JSON.parse(props.data.setTaskList);
                    }
                    if (props.data && props.data.hasOwnProperty('initSelected') && props.data.initSelected) {
                        this.initSelected = JSON.parse(props.data.initSelected);
                    }

                    //数据更新bus，监听后端发送数据
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        //监听主题色改变
                        if(props.themeNum){
                            this.themeNum = props.themeNum;
                        }
                        //监听数据改变
                        if (!props.data) {
                            return
                        }
                        if (props.data.hasOwnProperty('setTaskList') && props.data.setTaskList) {
                            this.taskListSource = JSON.parse(props.data.setTaskList);
                        }
                        if (props.data.hasOwnProperty('getSelected') && props.data.getSelected) {
                            this.getSelected = props.data.getSelected;
                        }
                        if (props.data.hasOwnProperty('updateTaskList') && props.data.updateTaskList) {
                            this.updateTaskList = JSON.parse(props.data.updateTaskList);
                        }
                        if (props.data.hasOwnProperty('initSelected') && props.data.initSelected) {
                            this.initSelected = JSON.parse(props.data.initSelected);
                        }
                    })

                    // this.taskListSource = [{"first_class":"教育/培训/科研","second_class":"中小学课程辅导","third_class":"兼职教师"},{"first_class":"物流/采购/供应链","second_class":"交通运输","third_class":"商务专职司机"},{"first_class":"教育/培训/科研","second_class":"职业培训","third_class":"职业技术教师"},{"first_class":"产品/项目/高级管理","second_class":"高级管理","third_class":"高级管理职位"}];

                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('cascaderSearch', MyComponent)
})(window.KDApi)
